export const REVALIDATE_INTERVAL_MS = 60_000;

export const isNewerEntry = (baked, fresh) =>
  Boolean(fresh) &&
  typeof fresh === 'object' &&
  fresh.__typename === baked?.__typename &&
  JSON.stringify(fresh) !== JSON.stringify(baked);

export const nextFreshState = ({ current, lastStamp }, answer) => {
  const stamp = Number(answer?.fetchedAt);

  if (!Number.isFinite(stamp) || stamp <= lastStamp) return { current, lastStamp };

  return {
    current: isNewerEntry(current, answer.entry) ? answer.entry : current,
    lastStamp: stamp,
  };
};
